import { render, staticRenderFns } from "./WmsSummary.vue?vue&type=template&id=16745012"
import script from "./WmsSummary.vue?vue&type=script&lang=js"
export * from "./WmsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports